import { IRequestValues } from '../updateUser'

export default function mapValuesToRequest(
  values: IRequestValues,
): IRequestBody {
  return {
    /* eslint-disable @typescript-eslint/camelcase */
    agreement: values.agreement,
    date_format: values.dateFormat,
    saved_lang: values.savedLang,
    time_format: values.timeFormat,
    /* eslint-enable */
  }
}

export interface IRequestBody {
  saved_lang:
    | 'pl_PL'
    | 'pl'
    | 'en'
    | 'de'
    | 'it'
    | 'es'
    | 'ru'
    | 'se'
    | 'hu'
    | 'cz'
    | 'bg'
    | 'pt_BR'
    | 'pt'
    | 'tr'
    | 'fr'
    | 'hr'
    | 'el'
    | 'fil'
    | 'ja'
    | 'ko'
    | 'ms'
    | 'th'
    | 'ro'
    | 'in'
    | 'uk'
  agreement?: boolean
  date_format?: string
  time_format?: string
}
